/**
 * Enum pour les types de tabs disponibles dans l'application
 */
export const TAB_TYPES = Object.freeze({
  TERMINOLOGIES: 'terminologies',
  CONCEPTS: 'concepts',
  ALIGNEMENTS: 'alignements',
  CORRESPONDANCES: 'correspondances'
});

/**
 * Configuration des tabs avec leurs propriétés
 * Chaque tab contient:
 * - name: identifiant unique du tab
 * - icon: chemin vers l'icône du tab
 * - urlParamName: nom court utilisé dans l'URL
 */
export const TAB_CONFIG = Object.freeze({
  [TAB_TYPES.TERMINOLOGIES]: {
    name: TAB_TYPES.TERMINOLOGIES,
    label: 'Terminologies',
    icon: '/wp-content/themes/ans/design-system/img/pictogrammes-illustratifs/Certificats_logiciels.svg',
    urlParamName: 'termino'
  },
  [TAB_TYPES.CONCEPTS]: {
    name: TAB_TYPES.CONCEPTS,
    label: 'Concepts',
    icon: '/wp-content/themes/ans/design-system/img/pictogrammes-illustratifs/Voir_toutes_les_demandes.svg',
    urlParamName: 'concept'
  },
  [TAB_TYPES.ALIGNEMENTS]: {
    name: TAB_TYPES.ALIGNEMENTS,
    label: 'Alignements',
    icon: '/wp-content/themes/ans/design-system/img/pictogrammes-illustratifs/Autres_Ressources_humaines.svg',
    urlParamName: 'alignement'
  }
});

/**
 * Vérifie si un nom de tab est valide
 * @param {string} tabName - Le nom du tab à vérifier
 * @returns {boolean} true si le tab existe
 */
export function isValidTabName(tabName) {
  return Object.values(TAB_TYPES).includes(tabName);
}

/**
 * Convertit un paramètre URL en nom de tab
 * @param {string} urlParam - Le paramètre URL ('termino' ou 'concept')
 * @returns {string|null} Le nom du tab correspondant ou null si invalide
 */
export function urlParamToTabName(urlParam) {
  const config = Object.values(TAB_CONFIG).find(tab => tab.urlParamName === urlParam);
  return config ? config.name : null;
}

/**
 * Convertit un nom de tab en paramètre URL
 * @param {string} tabName - Le nom du tab ('terminologies' ou 'concepts')
 * @returns {string|null} Le paramètre URL correspondant ou null si invalide
 */
export function tabNameToUrlParam(tabName) {
  const config = TAB_CONFIG[tabName];
  return config ? config.urlParamName : null;
}
